import React, { useEffect, useState } from "react";
import AguiMessage from "./aguiMessage";

interface AguiMsg {
  text: string;
  category: "broadcast" | "weather" | "lost_found";
  messageId: string;
  role?: string;
  timestamp?: number;
}

const AguiMessageList: React.FC = () => {
  const [messages, setMessages] = useState<AguiMsg[]>([]);

  useEffect(() => {
    const eventSource = new EventSource("/api/admin-message/stream");
    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        const { category, text } = JSON.parse(data.delta);
        setMessages((prev) => [
          ...prev,
          {
            text,
            category,
            messageId: data.messageId,
            role: data.role,
            timestamp: Date.now(),
          },
        ]);
      } catch (err) {
        // Ignore malformed events
      }
    };
    return () => eventSource.close();
  }, []);

  return (
    <div>
      {messages.map((msg) => (
        <AguiMessage key={msg.messageId} message={msg} />
      ))}
    </div>
  );
};

export default AguiMessageList; 